// extracted by mini-css-extract-plugin
module.exports = {"logo":"index-module--logo--3tl-x","screenshot":"index-module--screenshot--eZ8R2","boxTextContainer":"index-module--boxTextContainer--s9C8n"};